import {IAnyObject} from "./SimpleInterface";
import FileVO, {FileType} from "./FileVO";
import {isNumeric} from "./SiteHelper";

export type ImageSize =
    'full' |
    'small_square' |
    'small_landscape' |
    'small_portrait' |
    'large_square' |
    'large_landscape' |
    'large_portrait' |
    'full_hd' |
    'thumbnail' |
    'medium' |
    'medium_large' |
    'large' |
    's1536x1536' |
    's2048x2048' |
    'gform_image_choice_sm' |
    'gform_image_choice_md' |
    'gform_image_choice_lg';

const imageSizes:ImageSize[] = [
    'full',
    'small_square',
    'small_landscape',
    'small_portrait',
    'large_square',
    'large_landscape',
    'large_portrait',
    'full_hd',
    'thumbnail',
    'medium',
    'medium_large',
    'large',
    's1536x1536',
    's2048x2048',
    'gform_image_choice_sm',
    'gform_image_choice_md',
    'gform_image_choice_lg'
]

class ImageSizeVO
{
    size:ImageSize;
    url:string;
    width:number;
    height:number;

    constructor(size:ImageSize, url:string, width:number, height:number)
    {
        this.size = size;
        this.url = url;
        this.width = width;
        this.height = height;
    }
}

type IImageSizeVOs = {
    [key in ImageSize]: ImageSizeVO
};

type IMaybeImageSizeVOs = {
    [key in ImageSize]: ImageSizeVO|null
};

export default class ImageVO extends FileVO
{
    fileType: FileType = "image";

    width:number = 0;
    height:number = 0;

    size:IImageSizeVOs = null!;
    maybeSize:IMaybeImageSizeVOs = null!;

    constructor(object: IAnyObject|null = null)
    {
        super(null, true);
        this.populate(object ?? {});
    }

    populate(object: IAnyObject){
        super.populate(object);
        this.width = object.width && !isNaN( object.width) ? parseInt(object.width) : 0;
        this.height = object.height && !isNaN( object.height) ? parseInt(object.height) : 0;


        const fullSizeVO = new ImageSizeVO("full", this.url, this.width, this.height);

        const fromSizes:IAnyObject = object.sizes ?? {};
        const useFromSizes:IAnyObject = {};
        for(let key in fromSizes){
            const value = fromSizes[key];
            key = key.split("-").join("_");

            if(isNumeric(key.charAt(0))){
                key = "s" + key;
            }
            useFromSizes[key] = value;
        }
        const size:IAnyObject = {};
        const maybeSize:IAnyObject = {};
        for(let imageSize of imageSizes){
            let sizeVO:ImageSizeVO|null;
            if(imageSize === "full"){
                sizeVO = fullSizeVO;
            } else {
                const url:string  = useFromSizes[imageSize] ?? "";
                if(url){
                    const width:number  = parseInt(useFromSizes[imageSize + "_width"] ?? "0");
                    const height:number  = parseInt(useFromSizes[imageSize + "_height"] ?? "0");
                    sizeVO = new ImageSizeVO(imageSize, url, width, height);
                } else {
                    sizeVO = null;
                }
            }
            size[imageSize] = sizeVO ?? fullSizeVO;
            maybeSize[imageSize] = sizeVO;
        }

        this.size = size as IImageSizeVOs;
        this.maybeSize = size as IMaybeImageSizeVOs;
        this.valid = this.valid && !!fullSizeVO.url;
    }
}